<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>{{ $t('login.title') }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="text-center pt-4">
            <img src="/logo.png" alt="Logo" class="login-logo" />
          </v-card-text>
          <v-card-text>
            <v-form @submit.prevent="login">
              <v-text-field
                v-model="credentials.username"
                :label="$t('login.username')"
                name="username"
                prepend-icon="mdi-account"
                type="text"
                required
              />

              <v-text-field
                v-model="credentials.password"
                :label="$t('login.password')"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
                required
              />

              <div class="mt-2">
                <v-btn
                  color="primary"
                  type="submit"
                  :loading="loading"
                  block
                >
                  {{ loading ? $t('login.loading') : $t('login.loginButton') }}
                </v-btn>
              </div>
            </v-form>
          </v-card-text>

          <v-card-text v-if="error" class="error-message">
            <v-alert type="error" dense>
              {{ error }}
            </v-alert>
          </v-card-text>

          <v-card-text class="text-center pb-2">
            <span class="text-caption text-disabled">v{{ appVersion }}</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useAuthStore } from '../stores/auth.js'

export default {
  name: 'Login',
  mounted() {
    console.log('🔐 Login component mounted!')
  },
  data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      loading: false,
      error: null,
      appVersion: __APP_VERSION__
    }
  },
  methods: {
    async login() {
      this.loading = true
      this.error = null

      try {
        const authStore = useAuthStore()
        const result = await authStore.login(this.credentials)

        if (result.success) {
          // Reindirizza alla home dopo login riuscito
          this.$router.push('/')
        } else {
          // Gestisce diversi tipi di errore con traduzioni
          if (result.error?.includes('Database connection error')) {
            this.error = this.$t('login.errors.databaseError')
          } else if (result.error?.includes('Invalid credentials')) {
            this.error = this.$t('login.errors.invalidCredentials')
          } else if (result.error?.includes('password not configured')) {
            this.error = this.$t('login.errors.passwordNotConfigured')
          } else {
            this.error = result.error || this.$t('login.errors.unknownError')
          }
        }

      } catch (error) {
        this.error = this.$t('login.errors.serverError')
        console.error('Login failed:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-logo {
  max-width: 200px;
  max-height: 120px;
  width: auto;
  height: auto;
}
</style>
